import { useEffect } from 'react'

import { useSettings } from '@loadsmart/react-frontend-settings'

import { observeSettingsLoading } from 'core/infra/settings/settingsReadyStore'

/**
 * Renders nothing. Mounted directly under `SettingsProvider` at the app root so
 * it is always present while the settings provider performs its initial load.
 * It reports the loading flag into `settingsReadyStore`, which lets consumers
 * that mount later (e.g. `AppLayout` after the OpenDock auth redirect) still
 * learn that settings have settled.
 */
export default function SettingsReadyProbe() {
  const { isLoading } = useSettings([])

  useEffect(() => {
    observeSettingsLoading(isLoading)
  }, [isLoading])

  return null
}
